import { render, staticRenderFns } from "./vipManager.vue?vue&type=template&id=bad21f6c&"
import script from "./vipManager.vue?vue&type=script&lang=js&"
export * from "./vipManager.vue?vue&type=script&lang=js&"
import style0 from "./vipManager.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports